"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useSlidesVisibility = useSlidesVisibility;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var React = _interopRequireWildcard(require("react"));
var _isElementVisible = require("../utils/isElementVisible");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function useSlidesVisibility(_ref) {
  let {
    swiper,
    newbuildings,
    requiredVisibilityPercentHorizontal,
    requiredVisibilityPercentVertical,
    onVisibilityChange
  } = _ref;
  const shownSlidesIndexes = React.useRef(new Set([]));
  const visibleSlidesCount = React.useRef(null);
  const getVisibleSlidesIndexes = React.useCallback(() => {
    const extendedSwiper = swiper.current;
    if (!extendedSwiper) {
      return [];
    }
    if (visibleSlidesCount.current === null) {
      let visibleIndexes = extendedSwiper.visibleSlidesIndexes;
      if (!visibleIndexes?.length) {
        return [];
      }

      // обрабатываем кейс, когда из-за slidesOffsetBefore первый видимый слайд не является активным
      if (visibleIndexes[1] === extendedSwiper.realIndex) {
        visibleIndexes = visibleIndexes.slice(1);
      }
      const lastSlide = extendedSwiper.slides[visibleIndexes[visibleIndexes.length - 1]];
      const {
        isHorizontallyVisible,
        isVerticallyVisible
      } = (0, _isElementVisible.isElementVisible)(lastSlide, requiredVisibilityPercentHorizontal, requiredVisibilityPercentVertical);
      if (!isVerticallyVisible) {
        // проверка первого видимого слайда на случай, если библиотека определила последний видимый слайд неправильно
        const {
          isVerticallyVisible
        } = (0, _isElementVisible.isElementVisible)(extendedSwiper.slides[visibleIndexes[0]], requiredVisibilityPercentHorizontal, requiredVisibilityPercentVertical);

        // нет смысла вычислять, если слайды не видимы по вертикали. вычислим в следующий раз, когда юзер доскроллит до карусели
        if (!isVerticallyVisible) {
          return [];
        }
      }
      visibleSlidesCount.current = Math.max(isHorizontallyVisible ? visibleIndexes.length : visibleIndexes.length - 1, 1);
    }
    return [...Array(visibleSlidesCount.current).keys()].map(idx => extendedSwiper.realIndex + idx).filter(idx => idx <= extendedSwiper.slides.length - 1);
  }, [requiredVisibilityPercentHorizontal, requiredVisibilityPercentVertical, swiper]);
  const checkSlidesVisibility = React.useCallback(() => {
    const visibleIndexes = getVisibleSlidesIndexes();
    if (!visibleIndexes.length) {
      return;
    }
    const visibleNewbuildings = visibleIndexes.map(index => _objectSpread(_objectSpread({}, newbuildings[index]), {}, {
      index,
      isShownFirstTime: !shownSlidesIndexes.current.has(index)
    }));
    shownSlidesIndexes.current = new Set([...shownSlidesIndexes.current, ...visibleIndexes]);
    onVisibilityChange({
      newbuildings: visibleNewbuildings
    });
  }, [getVisibleSlidesIndexes, newbuildings, onVisibilityChange]);
  const recalculateVisibleSlidesCount = React.useCallback(() => {
    visibleSlidesCount.current = null;
  }, []);
  return {
    checkSlidesVisibility,
    recalculateVisibleSlidesCount
  };
}